import script from "./munsellColorSearch.vue?vue&type=script&setup=true&name=munsellColorSearch&lang=js"
export * from "./munsellColorSearch.vue?vue&type=script&setup=true&name=munsellColorSearch&lang=js"

const __exports__ = script;

export default __exports__